import {Dispatch} from "redux";
import {AccountAPI, MixesAPI} from "../services/api/Api";
import {IMix} from "../constants/types";
import {AppStateType} from "../services/rootReducer";

const GET_RECOMMENDED_MIXES_START = 'ForYou/GET_RECOMMENDED_MIXES_START';
const GET_RECOMMENDED_MIXES_SUCCESS = 'ForYou/GET_RECOMMENDED_MIXES_SUCCESS';
const SET_INDEX_RECOMMENDED_MIXES = 'ForYou/SET_INDEX_RECOMMENDED_MIXES';
const SET_STATE_REQUEST = 'ForYou/SET_STATE_REQUEST';
const UPDATE_FOR_YOU_MIX = 'ForYou/UPDATE_FOR_YOU_MIX';
const ADD_ACTIVE_TASTES_ID = 'ForYou/ADD_ACTIVE_TASTES_ID';
const REMOVE_ACTIVE_TASTES_ID = 'ForYou/REMOVE_ACTIVE_TASTES_ID';
const SET_ACTIVE_HARDNESS = 'ForYou/SET_ACTIVE_HARDNESS';
const REMOVE_ACTIVE_HARDNESS = 'ForYou/REMOVE_ACTIVE_HARDNESS';
const ADD_ACTIVE_BRANDS_ID = 'ForYou/ADD_ACTIVE_BRANDS_ID';
const REMOVE_ACTIVE_BRANDS_ID = 'ForYou/REMOVE_ACTIVE_BRANDS_ID';

interface IForYouState {
    isLoading: boolean,
    recommendedMixes: Array<IMix>,
    indexMix: number | null,
    requestCompleted: boolean,
    activeTastesId: Array<number>,
    activeHardnessId: number | null,
    activeBrandsId: Array<number>
}

interface IForYouAction {
    type: string,
    payload: any
}

const initialState: IForYouState = {
    isLoading: true,
    recommendedMixes: [],
    indexMix: null,
    requestCompleted: false,
    activeTastesId: [],
    activeHardnessId: null,
    activeBrandsId: []
};

const setRecommendedMixes = (res: Array<object>) => ({
    type: GET_RECOMMENDED_MIXES_SUCCESS,
    payload: res ? res : []
});

export const setIndexRecommendedMixes = (id: number) => (dispatch: Dispatch) => {
    dispatch({
        type: SET_INDEX_RECOMMENDED_MIXES,
        payload: id
    })
};

const addActiveTastesID = (id: number) => {
    return {
        type: ADD_ACTIVE_TASTES_ID,
        payload: id,
    };
};

const removeActiveTastesID = (id: number) => {
    return {
        type: REMOVE_ACTIVE_TASTES_ID,
        payload: id,
    };
};

const setActiveHardnessId = (id: number) => {
    return {
        type: SET_ACTIVE_HARDNESS,
        payload: id,
    };
};

const removeActiveHardnessId = (id: number) => {
    return {
        type: REMOVE_ACTIVE_HARDNESS,
        payload: id,
    };
};

const setActiveBrandsId = (id: number) => {
    return {
        type: ADD_ACTIVE_BRANDS_ID,
        payload: id,
    };
};

const removeActiveBrandsId = (id: number) => {
    return {
        type: REMOVE_ACTIVE_BRANDS_ID,
        payload: id,
    };
};

export const getRecommendedMixes = () => (dispatch: Dispatch) => {
    dispatch({type: GET_RECOMMENDED_MIXES_START});
    setTimeout(() => {
        MixesAPI.getMixesRecommended()
            .then(res => dispatch(setRecommendedMixes(res)))
            .catch(e => console.log(e));
        dispatch({type: SET_STATE_REQUEST});
    }, 250)
};

const changeForYouMix = (countLikes: number, isLiked: boolean, indexMix: number) => ({
    type: UPDATE_FOR_YOU_MIX,
    payload: [countLikes, isLiked, indexMix]
});

export const updateForYouMix = (id: number, isMixLiked: boolean) => {
    return async (dispatch: Dispatch, getState: () => AppStateType) => {
        const recommendedMixes = getState().forYou.recommendedMixes;
        const mixIndex = recommendedMixes.findIndex((item: any) => item.id === id);
        if (isMixLiked) {
            const res = await MixesAPI.unlikeMix(id);
            dispatch(changeForYouMix(res.likeCount, false, mixIndex));
        } else {
            const res = await MixesAPI.likeMix(id);
            dispatch(changeForYouMix(res.likeCount, true, mixIndex));
        }
    }
};

export const handleTastesId = (id: number) => async (dispatch: Dispatch, getState: () => AppStateType) => {
    const activeTastesId = getState().forYou.activeTastesId;
    if (activeTastesId.length) {
        activeTastesId.findIndex((item: number) => item === id) === -1
            ? dispatch(addActiveTastesID(id))
            : dispatch(removeActiveTastesID(id));

    } else {
        dispatch(addActiveTastesID(id));
    }
};

export const handleHardnessId = (id: number) => async (dispatch: Dispatch, getState: () => AppStateType) => {
    const activeHardness = getState().forYou.activeHardnessId;
    activeHardness === null || activeHardness !== id
        ? dispatch(setActiveHardnessId(id))
        : dispatch(removeActiveHardnessId(id));
};

export const handleBrandsId = (id: number) => async (dispatch: Dispatch, getState: () => AppStateType) => {
    const handleBrandsId = getState().forYou.activeBrandsId;
    if (handleBrandsId.length) {
        handleBrandsId.findIndex((item: number) => item === id) === -1
            ? dispatch(setActiveBrandsId(id))
            : dispatch(removeActiveBrandsId(id));

    } else {
        dispatch(setActiveBrandsId(id));
    }
};

export const sendUserPreferences = () => async (dispatch: Dispatch, getState: () => any) => {
    const state = getState().forYou;
    AccountAPI.updateAccountPreferences(
        state.activeBrandsId,
        state.activeHardnessId,
        state.activeTastesId)
        .then(res => res)
        .catch(e => console.log(e));
};

const ForYouReducer = (state = initialState, action: IForYouAction): IForYouState => {

    switch (action.type) {

        case GET_RECOMMENDED_MIXES_START:
            return {
                ...state,
                isLoading: true
            };

        case GET_RECOMMENDED_MIXES_SUCCESS:
            return {
                ...state,
                recommendedMixes: action.payload,
                isLoading: false
            };

        case SET_INDEX_RECOMMENDED_MIXES:
            return {
                ...state,
                indexMix: action.payload
            };

        case SET_STATE_REQUEST:
            return {
                ...state,
                requestCompleted: true
            };

        case UPDATE_FOR_YOU_MIX: {
            const newState: any = [...state.recommendedMixes];
            const [likeCount, isLiked, indexMix] = action.payload;
            newState[indexMix].isLiked = isLiked;
            newState[indexMix].likeCount = likeCount;
            return {
                ...state,
                recommendedMixes: newState
            }
        }

        case ADD_ACTIVE_TASTES_ID: {
            return {
                ...state,
                activeTastesId: [...state.activeTastesId, action.payload]
            }
        }

        case REMOVE_ACTIVE_TASTES_ID: {
            return {
                ...state,
                activeTastesId: state.activeTastesId.filter((item: number) => item !== action.payload)
            }
        }

        case SET_ACTIVE_HARDNESS: {
            return {
                ...state,
                activeHardnessId: action.payload
            }
        }

        case REMOVE_ACTIVE_HARDNESS: {
            return {
                ...state,
                activeHardnessId: null,
            }
        }

        case ADD_ACTIVE_BRANDS_ID: {
            return {
                ...state,
                activeBrandsId: [...state.activeBrandsId, action.payload]
            }
        }

        case REMOVE_ACTIVE_BRANDS_ID: {
            return {
                ...state,
                activeBrandsId: state.activeBrandsId.filter((item: number) => item !== action.payload)
            }
        }

        default:
            return state;
    }
};

export default ForYouReducer;
